import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
  ExpirationTimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { UsersSessionsActiveConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "users-sessions-active-details",
  templateUrl: "./users-sessions-active-details.component.html",
  standalone: false,
})
export class UsersSessionsActiveDetailsComponent
  extends BaseDetailsLogic<UsersSessionsActiveConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(
      analyticsService,
      authService,
      loggingService,
      UsersSessionsActiveConfig,
      tooltipCoordinator
    );
  }

  //TODO: Analytics:  Add TimePeriod select for sessionExpirationPeriod, see manuals-downloaded-details.component.ts and html, also add to html

  get sessionExpirationPeriod(): string | ExpirationTimePeriod {
    return this.config?.sessionExpirationPeriod as ExpirationTimePeriod;
  }

  set sessionExpirationPeriod(value: string | ExpirationTimePeriod) {
    this.config.sessionExpirationPeriod = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      expirationTimePeriod:
        'Choose how long a session should last before it is considered expired. For example, if you select "30 minutes", any session that has not been active for 30 minutes will be considered ended. This helps you see which sessions are currently active.',
      timePeriod:
        "Pick a time period to see data for that range. For example, you can look at results from the last week, month, or year. This helps you understand when things are happening.",
    };
  }
}
